module.exports = __webpack_public_path__ + "static/media/19.75ab1e93.png";